import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Layout from '../Layout';

class Row5 extends Component{
  render(){
    return(
      <Layout {...this.props} type="Row"></Layout>

    )
  }
}

Row5.propTypes = {
  childOf:PropTypes.string,
  values:PropTypes.object,
  cell: PropTypes.array,
  layout:PropTypes.func
};

export default Row5;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Row/Row5.js